import { useSelector } from 'react-redux';
import DateTimeComponent from '../config/util/DateAndTimeParser';

const useDateTime = () => {
    const dateFormat = useSelector((state) => state.AppReducer?.dateFormat);
    const timeFormat = useSelector((state) => state.AppReducer?.timeFormat);

    return (datetimeStr, type) => {
        return DateTimeComponent(datetimeStr, type, dateFormat, timeFormat);
    };
};

export default useDateTime;
